import { useSelector } from "react-redux";
import { QRCode } from "react-qrcode-logo";
import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";

const QRCodeGenerator = ({
  size,
  width,
  id,
  loading,
  setLoading,
  imageData,
  setImageData,
  qrcode,
}) => {
  const campaign_response = useSelector(
    (state) => state.campaign_states.campaign_response
  );
  const form = useSelector((state) => state.campaign_states.form);
  const campaignUrl = `${process.env.REACT_APP_CAMPAGIN_URL}/form/${campaign_response?._id}/landing`;
  const corsProxyUrl = "https://api.allorigins.win/raw?url=";

  const imageUrlToBase64 = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
      reader.onerror = reject;
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (form.campaign_brand_image?.includes("data")) {
        setLoading(false);
        setImageData(form.campaign_brand_image);
      } else {
        setLoading(true);
        imageUrlToBase64(`${corsProxyUrl}${form.campaign_brand_image}`)
          .then((data) => {
            setImageData(data);
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [form.campaign_brand_image]);

  return (
    <div className="d-flex justify-content-center">
      {loading && !qrcode ? (
        <div
          className=" d-flex justify-content-center"
          style={{
            marginTop: qrcode ? "0rem" : "13rem",
            marginRight: qrcode ? "5rem" : "",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <div>
          <QRCode
            id={id}
            size={size}
            value={campaignUrl}
            logoImage={imageData}
            logoWidth={width}
            logoHeight={width * 0.7}
          />
        </div>
      )}
    </div>
  );
};
export default QRCodeGenerator;
